<template>
  <hic-dialog append-to-body :close-on-click-modal="false" :visible="visible" width="90%" top="10vh" :title="title"
    @close="close" @open="open">
    <el-row type="flex" align="middle" style="text-align: left">
      <el-col>
        <el-radio-group v-model="condition.scope" @input="queryEntitie">
          <el-radio label="本人">本人</el-radio>
          <el-radio label="本科">本科</el-radio>
          <el-radio label="全院">全院</el-radio>
        </el-radio-group>
        <el-input class="condition-wide left-pad" v-model="condition.searchWord" placeholder="名称、关键字" size="small"
          v-on:keyup.enter.native="queryEntitie" clearable @clear="queryEntitie">
          <el-button type="info" :loading="meta.loading" slot="append" icon="el-icon-search" @click="queryEntitie">
          </el-button>
        </el-input>
      </el-col>
    </el-row>

    <el-container class="f-h mt10" ref="">
      <el-aside width="400px" style="border-right: 1px solid #ccc; min-height: 600px">
        <el-table :data="entities.items" v-loading="meta.loading">
          <el-table-column align="center" width="50" label="">
            <template slot-scope="{ row }">
              <el-checkbox v-model="row.checked" @change="(val) => selectTemp(val, row)"></el-checkbox>
            </template>
          </el-table-column>
          <el-table-column align="center" label="模板名称" prop="title"></el-table-column>
          <el-table-column align="center" label="关键字" prop="keyword"></el-table-column>
          <el-table-column align="center" label="备注" prop="memo"></el-table-column>
        </el-table>
      </el-aside>
      <el-container style="">
        <el-row style="width: 100%">
          <el-col style="height: 80%; position: relative">
            <!-- {{ selectTempList }} -->
            <el-table v-loading="meta.tmpl" ref="tmpRef" :data="entity.items" :loading="meta.loading" hide-footer
              @selection-change="selectionChange" height="30rem">

              <el-table-column align="center" width="10"><!--这列用颜色标记组数据--></el-table-column>
              <el-table-column align="center" type="selection" width="55"></el-table-column>

              <el-table-column column-key="type" align="center" width="100" label="类型" prop="type">
                <template slot-scope="{ row }">
                  <el-select v-if="!row.id" :disabled="!!row.name" v-model="row.type" size="small">
                    <el-option label="自动" value="自动" />
                    <el-option label="药品" value="药品" />
                    <el-option label="医技" value="医技" />
                    <el-option label="嘱托" value="嘱托" />
                  </el-select>
                  <div v-else>
                    <el-tag v-if="row.type == '药品'" type="primary" size="mini" hit effect="plain">{{ row.type
                      }}</el-tag>
                    <el-tag v-else-if="row.type == '草药'" type="warning" size="mini" hit effect="plain">{{ row.type
                      }}</el-tag>
                    <el-tag v-else-if="row.type == '医技'" type="danger" size="mini" hit effect="plain">{{ row.type
                      }}</el-tag>
                    <el-tag v-else-if="row.type == '嘱托'" type="info" hit size="small">{{ row.type }}</el-tag>
                    <el-tag v-else type="danger" effect="light" hit size="small">{{ row.type }}</el-tag>
                  </div>
                </template>
              </el-table-column>
              <el-table-column column-key="term" align="center" width="100" label="期效" prop="term">
                <template #default="{ row }">
                  <el-tag v-if="row.term == '长期'" type="success" size="mini" hit>{{ row.term }}</el-tag>
                  <el-tag v-else-if="row.term == '临时'" type="danger" size="mini" hit>{{ row.term }}</el-tag>
                  <el-tag v-else type="warning" size="mini" hit>{{ row.term }}</el-tag>
                </template>
              </el-table-column>
              <el-table-column align="" min-width="600" label="医嘱内容" prop="name">
                <template #default="{ row }">
                  <template v-if="row.name">
                    <editorDrug v-if="row.type == '药品'" :row="row" :isTmpl="true"> </editorDrug>
                    <editorMl v-else-if="row.type == '医技'" :row="row" :isEdit="!row.id" :readonly="true"> </editorMl>
                    <editorHerbal v-else-if="row.type == '草药'" :row="row" :readonly="true"></editorHerbal>
                    <el-input v-else-if="row.type == '嘱托' && false" class="" v-model="row.name" maxlength="500"
                      placeholder="请输入" size="small" clearable
                      @change="partSave(row, { id: row.id, name: row.name })"></el-input>
                    <div v-else-if="row.type == '转科' || row.type == '离院'">
                      <el-tag type="danger" hit style="border-left: 3rem solid #ff4949">
                        <span style="margin-left: -3rem; color: white">{{ row.type }}</span>
                        <span style="margin-left: 1.5rem">{{ row.content }}</span>
                      </el-tag>
                    </div>
                    <b v-else>{{ row.name }}</b>
                  </template>
                </template>
              </el-table-column>
              <el-table-column column-key="claimType" align="center" width="120" label="医保范围" prop="claimType">
                <template #default="{ row }">
                  <div>
                    <el-tag v-if="row.claimType == '医保外'" type="danger" hit size="small">{{ row.claimType }}</el-tag>
                    <el-tag v-else-if="!!row.claimType" type="success" hit size="small">{{ row.claimType }}</el-tag>
                  </div>
                </template>
              </el-table-column>
              <el-table-column align="left" width="160" label="嘱托" prop="content">
                <template #default="{ row }">
                  <div>{{ row.content }}</div>
                </template>
              </el-table-column>

              <el-table-column align="center" width="150" label="执行科室" prop="">
                <template #default="{ row }">
                  <div>{{ row.execDeptCode | dictText("Dept") }}</div>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
          <el-col style="padding: 20px 10px" class="left">
            <el-form ref="from" :model="temData" label-width="9rem" :rules="rules">
              <el-form-item label="开始时间：" prop="startTime">
                <el-date-picker size="small" v-model="temData.startTime" type="datetime"
                  placeholder="请选择开始时间"></el-date-picker>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
      </el-container>
    </el-container>
    <template slot="footer">
      <el-button @click="$emit('update:visible', false)">取消</el-button>
      <el-button type="primary" @click="save" class="left-pad">提交</el-button>
    </template>
  </hic-dialog>
</template>
<script>
import { mapGetters } from "sw-hic";
import api from "../api";
export default {
  props: {
    title: String,
    visible: Boolean,
    list: Array,
  },
  components: {
    editorDrug: () => import("./_editorDrug"),
    editorMl: () => import("./_editorMl"),
    editorHerbal: () => import("./_editorHerbal"),
  },
  data() {
    return {
      meta: {
        loading: false,
        tmpl: false
      },
      entities: {},
      condition: {
        scope: "本人",
      },
      adviceEntitie: {},
      selectTempList: [],
      temData: {
        startTime: '',
      },
      rules: {
        startTime: [{ required: true, message: "请选择开始时间", trigger: "change" }],
      },
      aaaa: "",
      handleSelectionChanges: [],
      entity: {}
    };
  },
  computed: {
    ...mapGetters(["user"]),
  },
  mounted() { },
  inject: ["proto"], // 注入父类方法
  methods: {
    close() {
      this.$emit("update:visible", false);
    },
    open() {
      this.$set(this.condition, 'scope', '本人')
      this.$set(this.temData, 'startTime', this.$utils.Fmt.datetime(new Date()))
      this.queryEntitie();
    },
    queryEntitie() {
      this.meta.loading = true;
      api.AdvicePackage.query(this.condition)
        .then((res) => {
          this.entities = res;
          if (res.items.length > 0) this.selectTemp(true, res.items[0]);
          else this.selectTemp(false);
        })
        .catch((err) => {
          this.$message.error(err.message || err);
        })
        .finally(() => {
          this.meta.loading = false;
        });
    },
    selectTemp(val, tmp) {
      if (val) {
        this.entities.items.forEach((ele) => {
          this.$set(ele, "checked", ele.id == tmp.id);
        });
        this.meta.tmpl = true
        this.$set(this.entity, 'items', [])
        setTimeout(() => {
          this.selectTempList = JSON.parse(tmp.details).items || JSON.parse(tmp.details);
          this.selectTempList.forEach((ele) => {
            delete ele.id
            if (ele.type == "药品" && ele.ipUsage != "PiShi") this.checkDrugCounts(ele);
          });
          this.$set(this.entity, 'items', this.selectTempList)
          try {
            this.$refs.tmpRef.toggleAllSelection()
          } catch (error) {
            debugger
          }
          this.meta.tmpl = false
        }, 300)


      } else {
        this.entity.items = []
        // this.$set(this,'selectTempList',[])
        // this.selectTempList = [];
      }
    },
    async checkDrugCounts(ele) {
      let res = await api.Drug.getDrugs({ code: ele.code });
      console.log("res===", res);
      if (res.items.length > 0) {
        if (!res.items[0].quantity || res.items[0].quantity <= 0) this.$set(ele, "state", "废弃");
      }
    },
    selectionChange(items) {
      this.handleSelectionChanges = items;
    },
    save() {
      if (this.handleSelectionChanges.length == 0) return this.$message.warning("请选择模板");
      this.$refs.from.validate((valid) => {
        if (valid) {
          let selItems = [];
          this.handleSelectionChanges.forEach((_obj) => {
            if (_obj.state != "废弃") {
              _obj.startTime = this.$utils.Fmt.datetime(this.temData.startTime);
              console.log('=============>', this.proto())
              this.$utils.Obj.propertyCopy(this.proto(), _obj, ["state", "hospitalizationId", "bedNo", "ipNo", "patientCode", "patientName", "doctorName", "doctorCode"]);
              let _delCols = [
                'id', 'no', 'lockKey', 'execTime', 'execUserCode', 'execUserName', 'execDeptCode', 'stopTime', 
                'endTime', 'stopDoctorCode', 'stopDoctorName', 'stopNurseCode', 'stopNurseName', 
                'issuedTime', 'issuedNurseCode', 'issuedNurseName']
              _delCols.forEach(ele => {
                delete _obj[ele]
              })
              selItems.push(_obj);
            }
          });
          console.log('selItems=============', selItems)
          // return
          if (selItems.length > 0) {
            // selItems.forEach(ele=>{
            // if(ele.type == '检查' || ele.type == '检验'){
            //     this.$set(ele,"state",'待校对')
            //     this.$set(ele,"issuedTime",this.$utils.Fmt.datetime(new Date()))
            // } else{
            //     this.$set(ele,"state",'草稿')
            // }
            // let _obj = {}
            // this.$utils.Obj.propertyCopy(_obj,this.baseAdvice)
            // delete _obj.term
            // this.$set(ele,"startTime",this.temData.startTime)

            // this.$utils.Obj.propertyCopy(ele,_obj)

            // if(!ele.lockKey) delete ele.lockKey
            // if(!ele.id) delete ele.id
            // })

            this.meta.loading = true;
            api.Advice.addAdviceBatch({ advices: selItems })
              .then((res) => {
                this.$message.success("提交成功");
                this.close();
                this.$emit("close");
              })
              .catch((err) => {
                this.$message.error(err.message || err);
              })
              .finally(() => {
                this.meta.loading = false;
              });
          } else {
            this.$message.warning("请选择模板");
          }
        }
      });
    },
  },
};
</script>
